export const articles: Record<string, {
  id: string;
  title: string;
  summary: string;
  content: string;
  date: string;
  readTime: string;
  image: string;
  tags: string[];
  category: string;
}> = {
  'article-1': {
    id: 'article-1',
    title: '17c 平台快速上手指南',
    summary: '本文将带您快速了解 17c 平台的基本操作流程，从注册到完成第一个任务，让您在十分钟内掌握核心用法。',
    content: `<p>欢迎来到 17c 平台！作为新用户，您可能对平台的功能和操作方式还不太熟悉。本文将带您快速了解 17c 的基本操作流程，帮助您在短时间内上手使用。</p>
    <h2>第一步：注册账号</h2>
    <p>访问 17c 官网，点击右上角的"注册"按钮。您可以选择使用手机号或邮箱进行注册。输入验证码后，设置您的登录密码，即可完成注册。建议您在注册后完善个人资料，这有助于获得更个性化的服务体验。</p>
    <h2>第二步：了解主界面</h2>
    <p>登录后，您将看到 17c 的主界面。左侧是导航菜单，包含了所有功能模块的入口。中间区域是工作区，您的主要操作都在这里完成。右侧是信息面板，显示通知、待办事项等内容。</p>
    <h2>第三步：完成第一个任务</h2>
    <p>点击"新建任务"按钮，填写任务名称和描述，设置截止日期和优先级，然后点击保存。恭喜您，已经完成了在 17c 上的第一个操作！接下来您可以尝试更多功能，逐步探索 17c 的强大能力。</p>
    <h2>第四步：个性化设置</h2>
    <p>进入设置中心，您可以根据自己的偏好调整界面主题、通知方式、语言等选项。合理配置这些设置，能让您的使用体验更加舒适高效。</p>`,
    date: '2026-08-10',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20workspace%20with%20laptop%20displaying%20clean%20dashboard%20interface%2C%20warm%20ambient%20lighting%2C%20organized%20desk%20setup%2C%20professional%20environment%2C%20soft%20neutral%20tones&width=1200&height=600&seq=article-1-hero&orientation=landscape',
    tags: ['入门', '教程', '新手'],
    category: '基础入门',
  },
  'article-4': {
    id: 'article-4',
    title: '数据管理功能深度解析',
    summary: '深入了解 17c 的数据管理功能，包括数据导入导出、分类整理、批量操作等核心能力。',
    content: `<p>数据管理是 17c 平台的核心功能之一。无论您是个人用户还是企业团队，高效的数据管理能力都能帮您节省大量时间和精力。本文将深度解析 17c 的数据管理功能。</p>
    <h2>数据导入</h2>
    <p>17c 支持多种数据导入方式：您可以直接拖拽文件到上传区域，支持 CSV、Excel、JSON 等常见格式。系统会自动识别数据结构并进行格式化处理，确保数据完整准确地导入平台。</p>
    <h2>数据分类与整理</h2>
    <p>导入数据后，您可以使用 17c 的标签系统和文件夹功能对数据进行分类整理。支持多级分类、交叉标签，让您在需要时快速找到目标数据。</p>
    <h2>批量操作</h2>
    <p>当需要处理大量数据时，17c 的批量操作功能可以大幅提升效率。您可以选择多条数据记录，一次性进行编辑、移动、删除或导出操作。批量操作支持筛选后的数据集合，让精准操作成为可能。</p>
    <h2>数据导出与备份</h2>
    <p>17c 提供灵活的数据导出选项，支持按分类、按标签、按时间范围等多种筛选方式导出数据。系统还会自动进行数据备份，确保您的数据安全无忧。</p>`,
    date: '2026-08-09',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20data%20analytics%20dashboard%20displaying%20charts%20and%20graphs%20on%20large%20monitor%2C%20clean%20minimal%20workspace%2C%20warm%20lighting%2C%20professional%20setting%2C%20soft%20neutral%20background&width=1200&height=600&seq=article-4-hero&orientation=landscape',
    tags: ['数据', '管理', '功能'],
    category: '功能详解',
  },
  'article-7': {
    id: 'article-7',
    title: 'API 接口调用完全指南',
    summary: '面向开发者的 17c API 接口文档，包含详细的调用示例、参数说明和最佳实践。',
    content: `<p>17c 平台提供了丰富的 API 接口，允许开发者将 17c 的功能集成到自己的应用中。本文是面向开发者的完整 API 调用指南。</p>
    <h2>获取 API 密钥</h2>
    <p>首先，您需要在 17c 设置中心生成 API 密钥。进入"开发者设置"页面，点击"创建 API 密钥"，设置权限范围后即可获取您的专属密钥。请妥善保管密钥，不要将其暴露在公开代码中。</p>
    <h2>基础请求格式</h2>
    <p>17c API 使用 RESTful 风格，所有请求均通过 HTTPS 进行。请求头需要包含您的 API 密钥进行身份验证。响应数据采用 JSON 格式，包含了状态码、数据内容和可能的错误信息。</p>
    <h2>核心接口说明</h2>
    <p>用户管理接口：支持用户信息的查询、创建和更新操作。数据操作接口：提供数据的增删改查功能，支持分页和条件筛选。文件管理接口：实现文件的上传、下载和删除操作。</p>
    <h2>最佳实践</h2>
    <p>建议在调用 API 时实施合理的频率控制，避免过于频繁的请求。对于批量操作，优先使用批量接口而非循环调用单个接口。处理好异常情况，确保应用的健壮性。</p>`,
    date: '2026-08-06',
    readTime: '15分钟',
    image: 'https://readdy.ai/api/search-image?query=Code%20editor%20displaying%20API%20documentation%20on%20computer%20screen%2C%20dark%20theme%20IDE%2C%20modern%20developer%20workspace%2C%20warm%20ambient%20lighting%2C%20minimal%20setup&width=1200&height=600&seq=article-7-hero&orientation=landscape',
    tags: ['API', '开发', '接口'],
    category: '进阶技巧',
  },
  'article-9': {
    id: 'article-9',
    title: '电商团队如何利用 17c 提升运营效率',
    summary: '某电商团队通过 17c 平台实现了运营流程的全面优化，订单处理时间缩短了60%，客户满意度显著提升。',
    content: `<p>在电商行业竞争日益激烈的今天，运营效率直接决定了企业的竞争力。本文将分享某电商团队如何借助 17c 平台实现运营效率的全面提升。</p>
    <h2>背景与挑战</h2>
    <p>该电商团队日均处理订单超过5000单，原有的管理系统已经无法满足快速增长的业务需求。订单处理延迟、数据统计混乱、团队协作不畅等问题严重影响了客户体验。</p>
    <h2>解决方案</h2>
    <p>团队决定全面接入 17c 平台，利用其强大的数据管理、自动化工作流和团队协作功能，对运营流程进行全面优化。通过 API 接口将 17c 与现有电商系统无缝对接，实现了数据的实时同步。</p>
    <h2>实施成果</h2>
    <p>经过三个月的实施和优化，团队取得了显著成效：订单处理时间缩短了60%，数据统计准确率提升至99.9%，团队协作效率提升了50%，客户满意度评分从4.1提升至4.8。</p>
    <h2>经验总结</h2>
    <p>该团队负责人表示，17c 最大的价值在于其灵活性和可扩展性。无论是小型团队还是大型企业，都可以根据自身需求灵活配置，逐步扩展使用范围。</p>`,
    date: '2026-08-04',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=E-commerce%20team%20working%20in%20modern%20office%20with%20computers%20displaying%20sales%20dashboards%2C%20collaborative%20atmosphere%2C%20warm%20lighting%2C%20professional%20setting&width=1200&height=600&seq=article-9-hero&orientation=landscape',
    tags: ['电商', '案例', '效率'],
    category: '实战案例',
  },
  'article-11': {
    id: 'article-11',
    title: '17c V3.2 版本更新公告',
    summary: '全新的界面设计、更强大的数据分析工具以及多项性能优化，17c V3.2 为您带来焕然一新的使用体验。',
    content: `<p>我们很高兴地宣布，17c V3.2 版本正式发布！本次更新带来了全新的界面设计和多项重要功能升级，让我们一起来看看有哪些变化。</p>
    <h2>全新界面设计</h2>
    <p>V3.2 版本对整体界面进行了重新设计，采用了更简洁的布局和更舒适的配色方案。新的导航系统让功能入口更加清晰，操作路径更短，使用体验更加流畅。</p>
    <h2>数据分析工具升级</h2>
    <p>数据分析模块新增了可视化报表功能，支持自定义图表类型和数据维度。您可以更直观地查看数据趋势，快速生成专业的分析报告。</p>
    <h2>性能全面优化</h2>
    <p>本次更新对底层架构进行了深度优化，页面加载速度提升了40%，大数据量操作的响应时间缩短了50%。同时优化了移动端的适配体验。</p>
    <h2>其他更新</h2>
    <p>新增了批量导入导出功能、优化了通知系统的推送逻辑、修复了若干已知问题。感谢所有用户的支持和反馈！</p>`,
    date: '2026-08-01',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20software%20update%20announcement%20screen%20with%20version%20number%20and%20new%20features%20list%2C%20clean%20minimal%20design%2C%20warm%20gradient%20background%2C%20professional%20UI&width=1200&height=600&seq=article-11-hero&orientation=landscape',
    tags: ['更新', '版本', '新功能'],
    category: '更新动态',
  },
  'article-13': {
    id: 'article-13',
    title: '17c 平台常见问题汇总',
    summary: '整理了用户最常询问的问题，涵盖账号、功能、付费、安全等各个方面，帮助您快速找到答案。',
    content: `<p>本文汇总了用户在 17c 平台上最常遇到的问题和解答，帮助您快速解决使用过程中的疑惑。</p>
    <h2>账号相关</h2>
    <p><strong>Q: 如何修改登录密码？</strong></p>
    <p>A: 登录后进入"设置"页面，点击"账号安全"，选择"修改密码"，按照提示操作即可。</p>
    <p><strong>Q: 忘记密码怎么办？</strong></p>
    <p>A: 在登录页面点击"忘记密码"，输入注册时使用的手机号或邮箱，按照收到的验证指引重置密码。</p>
    <h2>功能使用</h2>
    <p><strong>Q: 如何邀请团队成员？</strong></p>
    <p>A: 在团队管理页面点击"邀请成员"，输入对方的邮箱地址，系统会自动发送邀请链接。</p>
    <p><strong>Q: 数据可以导出到本地吗？</strong></p>
    <p>A: 可以。在数据页面选择要导出的数据，点击"导出"按钮，选择需要的格式即可下载到本地。</p>
    <h2>安全与隐私</h2>
    <p><strong>Q: 17c 如何保障我的数据安全？</strong></p>
    <p>A: 我们采用业界领先的加密技术保护您的数据，所有数据传输均通过 HTTPS 加密，数据存储采用多重备份机制。</p>`,
    date: '2026-08-11',
    readTime: '14分钟',
    image: 'https://readdy.ai/api/search-image?query=FAQ%20help%20center%20webpage%20with%20question%20and%20answer%20cards%2C%20clean%20minimal%20design%2C%20organized%20layout%2C%20warm%20neutral%20tones%2C%20professional%20support%20page&width=1200&height=600&seq=article-13-hero&orientation=landscape',
    tags: ['FAQ', '问答', '帮助'],
    category: '常见问题',
  },
};

export const allArticleIds = ['article-1', 'article-4', 'article-7', 'article-9', 'article-11', 'article-13'];

export const articleList = allArticleIds.map((id) => {
  const a = articles[id];
  return {
    id: a.id,
    title: a.title,
    summary: a.summary,
    date: a.date,
    readTime: a.readTime,
    image: a.image,
    tags: a.tags,
    category: a.category,
  };
});